import React, { useState, useEffect } from 'react';
import { generatePlanAction, getProjects } from '../services/projectService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { decodeToken } from "../utils/authUtils";
import { DecodedToken } from "../interfaces/decodeToken";
import { Autocomplete, TextField, Chip } from '@mui/material';
import { Project } from "../interfaces/Project";
import { PlanAction } from '../interfaces/PlanAction';

interface PlanActionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: () => void;
    planAction: PlanAction | null;
}

const PlanActionModal: React.FC<PlanActionModalProps> = ({ isOpen, onClose, onSave, planAction }) => {
    const [error, setError] = useState<string>('');
    const [selectedProject, setSelectedProject] = useState<Project[]>([]);
    const [projects, setProjects] = useState<Project[]>([]);

    const fetchProjects = async () => {
        try {
            const projectsData = await getProjects();
            setProjects(projectsData.data as Project[]);  // Mise à jour de l'état des projets
        } catch (error) {
            console.error('Erreur lors de la récupération des projets:', error);
        } finally {
        }
    };

    useEffect(() => {
        const token = sessionStorage.getItem('tokenAdminUI');
        if (token) {
            const decoded = decodeToken(token) as DecodedToken | null;
            if (decoded && decoded.sub) {
                //setIdUser(Number(decoded.sub));
            } else {
                toast.error('Impossible de récupérer l\'ID utilisateur.');
            }
        }

        fetchProjects();
    }, []);


    const handleGenerate = async () => {
        if (selectedProject.length === 0) {
            setError('Veuillez sélectionner au moins un projet.');
            toast.error('Veuillez sélectionner au moins un projet.');
            return;
        }

        setError('');

        try {
            const prjIds = selectedProject.map(prj => prj.id);
            if (prjIds.length > 0) {
                // Générer des plans d'actions pour chaque projet
                await Promise.all(prjIds.map(prj => generatePlanAction(prj)));
                toast.success('Génération des plans d\'action réussie !');
            }

            onSave();
            onClose();
        } catch (error) {
            toast.error('Erreur lors de la génération des plans d\'action.');
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white p-8 rounded-lg shadow-md max-w-lg w-full">
                    <h2 className="text-2xl font-bold mb-4">Générer des plans d'actions</h2>

                    {error && <div className="text-red-500 mb-4">{error}</div>}

                    {/* Autocomplete avec chips */}
                    <div className="mb-4">
                        <Autocomplete
                            multiple
                            options={projects}
                            getOptionLabel={(option) => '( ID : ' + option.id + ') -> ' + option.libelle }
                            value={selectedProject}
                            onChange={(event, newValue) => setSelectedProject(newValue)}
                            renderTags={(value: Project[], getTagProps) =>
                                value.map((option, index) => (
                                    <Chip label={option.libelle} {...getTagProps({ index })} key={option.id} />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Projets"
                                    placeholder="Sélectionnez des projets"
                                />
                            )}
                        />
                    </div>

                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="bg-gray-300 text-black px-4 py-2 rounded-md mr-2"
                        >
                            Annuler
                        </button>
                        <button
                            onClick={handleGenerate}
                            className="bg-blue-500 text-white px-4 py-2 rounded-md "
                        >
                            Générer
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PlanActionModal;
